import { RequestQueryOptions } from '@approvalmax/data';
import { selectors } from 'modules/common';
import { domain } from 'modules/data';
import { useSelector } from 'modules/react-redux';
import { GetOcrSuggests, useGetOcrSuggests } from 'shared/data/webApp/v2';
import { isOcrEnabledForTemplate } from 'shared/helpers';

import { useGetContactIdForOcrSuggests } from './useGetContactIdForOcrSuggests';

export const useOcrData = (
    request: domain.Request | null,
    attachmentId?: string,
    queryOptions?: RequestQueryOptions<GetOcrSuggests>
) => {
    const company = useSelector((state) =>
        request ? selectors.company.getCompanyById(state, request.companyId) : null
    );

    const contactId = useGetContactIdForOcrSuggests(request);

    return useGetOcrSuggests(
        {
            path: {
                requestId: request?.id,
                companyId: request?.companyId,
                attachmentId,
            },
            query: { contactId },
        },
        { enabled: isOcrEnabledForTemplate(company, request?.integrationCode), staleTime: 1000 * 60, ...queryOptions }
    );
};
